import BaseModelAPI from '../BaseModelAPI';

export default class ReportSummaryNG extends BaseModelAPI {
	static entity = 'newreport2018';
	static entityName = 'reportsummaryng';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.filterPeriodFrom = '';
			this.tempId = 0;
			this.item = '';
			this.total = 0;
			this.m1 = 0;
			this.m2 = 0;
			this.m3 = 0;
			this.m4 = 0;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}